import { allGoogleFonts } from './allGoogleFonts';

let fonts = [
  'Abel',
  'Abril Fatface',
  'Acme',
  'Amatic SC',
  'Anton',
  'Archivo Narrow',
  'Arimo',
  'Arvo',
  'Asap',
  'Assistant',
  'Barlow',
  'Bitter',
  'Bree Serif',
  'Cabin',
  'Cairo',
  'Catamaran',
  'Cinzel',
  'Comfortaa',
  'Crete Round',
  'Crimson Text',
  'Dancing Script',
  'Domine',
  'Dosis',
  'EB Garamond',
  'Exo',
  'Exo 2',
  'Fira Sans',
  'Fira Sans Condensed',
  'Fjalla One',
  'Francois One',
  'Gloria Hallelujah',
  'Heebo',
  'Hind',
  'Hind Madurai',
  'Hind Siliguri',
  'Inconsolata',
  'Indie Flower',
  'Inter',
  'Josefin Sans',
  'Kanit',
  'Karla',
  'Lato',
  'Libre Baskerville',
  'Libre Franklin',
  'Lobster',
  'Lora',
  'Maven Pro',
  'Merriweather',
  'Merriweather Sans',
  'Montserrat',
  'Mukta',
  'Muli',
  'Nanum Gothic',
  'News Cycle',
  'Noticia Text',
  'Noto Sans',
  'Noto Sans JP',
  'Noto Sans KR',
  'Noto Sans TC',
  'Noto Serif',
  'Nunito',
  'Nunito Sans',
  'Open Sans',
  'Open Sans Condensed',
  'Oswald',
  'Overpass',
  'Oxygen',
  'PT Sans',
  'PT Sans Narrow',
  'PT Serif',
  'Pacifico',
  'Permanent Marker',
  'Play',
  'Playfair Display',
  'Poppins',
  'Questrial',
  'Quicksand',
  'Rajdhani',
  'Raleway',
  'Righteous',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',
  'Rokkitt',
  'Ropa Sans',
  'Rubik',
  'Shadows Into Light',
  'Signika',
  'Slabo 27px',
  'Source Code Pro',
  'Source Sans Pro',
  'Source Serif Pro',
  'Teko',
  'Titillium Web',
  'Ubuntu',
  'Ubuntu Condensed',
  'Varela Round',
  'Vollkorn',
  'Work Sans',
  'Yanone Kaffeesatz',
];

fonts = Array.from(new Set([...fonts, ...allGoogleFonts]));

const getFonts = async () => {
  const url =
    'https://www.googleapis.com/webfonts/v1/webfonts' +
    '?sort=popularity&key=AIzaSyAn2p_z3opKV9ejkE9kwMtS6epmEAGNF-8';
  const result = await fetch(url);
  const resultJson = await result.json();

  if (!result.ok) {
    throw new Error(resultJson.errors);
  }

  return (fonts = resultJson.items
    // .slice(0, 100)
    .map(f => f.family)
    .sort());
};

export default fonts;
export { getFonts };
